import { isTreeStructurePath, isTreeStructurePruned, isTreeStructureTerminator } from './defaultMenuStructure';
const debug = process.env.REACT_APP_DEBUG && false;
export const pruneTreeByDefinition = ({ treeStructureDefinitionMap, iteration = 0, canary = '' }) => {
    debug && iteration === 0 && console.log(`DEBUG: iteration ${iteration}, pruning`, { treeStructureDefinitionMap });
    Object.entries(treeStructureDefinitionMap).reduce((a, [k, definition]) => {
        try {
            debug && console.log(`prune processing ${canary}${k}`, definition, treeStructureDefinitionMap);
            const matchedTreeStructureDefinition = treeStructureDefinitionMap[k];
            if (matchedTreeStructureDefinition) {
                if (isTreeStructurePruned(matchedTreeStructureDefinition)) {
                    debug && console.log(`prune deleting ${k} from`, treeStructureDefinitionMap);
                    delete treeStructureDefinitionMap[k];
                }
                else if (isTreeStructurePath(matchedTreeStructureDefinition)) {
                    pruneTreeByDefinition({
                        treeStructureDefinitionMap: matchedTreeStructureDefinition.next,
                        iteration: iteration + 1,
                        canary: `${k} > ` + canary,
                    });
                }
                else {
                    debug && console.log('prune where next', matchedTreeStructureDefinition);
                }
            }
            else {
                debug && console.log('prune fell through logic', treeStructureDefinitionMap);
            }
        }
        catch (e) {
            debug && console.log(e);
        }
        return treeStructureDefinitionMap;
    }, treeStructureDefinitionMap);
    return treeStructureDefinitionMap;
};
/** removes targetted part of tree based on key path like [ 'Admin', 'Devices' ] */
export const pruneTreeByPath = ({ treeStructureDefinitionMap, prunePath }) => {
    if (prunePath.length > 1) {
        const nextPrunePath = [...prunePath];
        const thisPath = nextPrunePath.shift();
        const thisTreeStructureSection = treeStructureDefinitionMap[thisPath];
        if (isTreeStructurePath(thisTreeStructureSection)) {
            const nextTreeStructureDefinitionMap = thisTreeStructureSection.next;
            return pruneTreeByPath({ treeStructureDefinitionMap: nextTreeStructureDefinitionMap, prunePath: nextPrunePath });
        }
        else if (isTreeStructureTerminator(thisTreeStructureSection)) {
            debug && console.log(`pruneTreeByPath at ${thisPath} encountered terminated path before consuming path`, treeStructureDefinitionMap);
            return treeStructureDefinitionMap;
        }
        else {
            debug && console.log(`pruneTreeByPath at ${thisPath} encountered unhandled tree part type`, treeStructureDefinitionMap);
            return treeStructureDefinitionMap;
        }
    }
    else if (prunePath.length === 1) {
        const terminatingPathKey = prunePath.at(0);
        if (treeStructureDefinitionMap[terminatingPathKey]) {
            delete treeStructureDefinitionMap[terminatingPathKey];
        }
        else {
            debug && console.log(`pruneTreeByPath at ${terminatingPathKey} failed to hit existing key`, treeStructureDefinitionMap);
            throw new Error(`pruneTreeByPath at ${terminatingPathKey} failed to hit existing key`);
        }
        return treeStructureDefinitionMap;
    }
    else {
        throw new Error(`pruneTreeByPath consumed all of path without returning`);
    }
};
export const pruneTreeByPathMap = ({ treeStructureDefinitionMap, prunePathMap, iteration = 0, canary = '' }) => {
    debug && iteration === 0 && console.log(`DEBUG: iteeration ${iteration}, pruning`, { prunePathMap });
    Object.entries(prunePathMap).reduce((a, [pruneKey, pruneConfig]) => {
        try {
            debug && console.log(`prune processing ${canary}${pruneKey}`, pruneConfig, treeStructureDefinitionMap);
            const matchedTreeStructureDefinition = treeStructureDefinitionMap[pruneKey];
            if (matchedTreeStructureDefinition) {
                if (shouldBePruned(pruneConfig, matchedTreeStructureDefinition)) {
                    debug && console.log(`prune deleting ${pruneKey} from`, treeStructureDefinitionMap);
                    delete treeStructureDefinitionMap[pruneKey];
                }
                else if (isTreeStructurePath(matchedTreeStructureDefinition)) {
                    pruneTreeByPathMap({
                        treeStructureDefinitionMap: matchedTreeStructureDefinition.next,
                        prunePathMap: pruneConfig,
                        iteration: iteration + 1,
                        canary: `${pruneKey} > ` + canary,
                    });
                }
                else {
                    debug && console.log('prune where next', matchedTreeStructureDefinition);
                }
            }
            else {
                debug && console.log('prune fell through logic', treeStructureDefinitionMap);
            }
        }
        catch (e) {
            debug && console.log(e);
        }
        return treeStructureDefinitionMap;
    }, treeStructureDefinitionMap);
    return treeStructureDefinitionMap;
};
const shouldBePruned = (pruneConfig, treeStructurePart) => {
    /** 24 July 2025 ADH - I don't know why the tree pruning is restricted to only valid tree items. I had problems where I wanted to prune
     * the Device menu item from the default Admin menu but it was going through anyway because somewhere in the merge code the device lost
     * it's 'next' and 'treeFC' properties so it wasn't valid, but it had a menuConfig item, which I guess lets {@link instantiateTree}
     * render an empty menu item.
     *
     * Is there any reason a menu item should be present but not prunable ??? */
    //const prunable = isTreeStructurePath(treeStructurePart) || isTreeStructureTerminator(treeStructurePart)
    const prunable = true;
    const configuredToPrune = typeof pruneConfig === 'string' || (typeof pruneConfig === 'object' && Object.keys(pruneConfig).length === 0);
    const prune = !!prunable && !!configuredToPrune;
    if (!prune) {
        debug && console.log(`should be pruned, config ${configuredToPrune}, treePart ${prunable}`, pruneConfig, treeStructurePart);
    }
    return prune;
};
